import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Import Tabler CSS
import '@tabler/core/dist/css/tabler.min.css';
// Import Tabler JS
import '@tabler/core/dist/js/tabler.min.js';
// Import custom theme with cache-busting query parameter
import './styles/custom-theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Add a console log to verify new deployment
console.log('App version:', process.env.REACT_APP_BUILD_TIME || 'development');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
